import React, { MouseEventHandler, ReactNode } from 'react';

import { MenuItem } from '@infoods/lifebase-ui';

import classes from './UserMenuItem.module.scss';

type UserMenuItemProps = {
  label: ReactNode;
  onClick: MouseEventHandler<HTMLLIElement>;
  startIcon: ReactNode;
  endIcon?: ReactNode;
};

const UserMenuItem = ({ label, onClick, startIcon, endIcon }: UserMenuItemProps) => {
  return (
    <MenuItem onClick={onClick} className={classes.menuItem}>
      {startIcon}
      <span>{label}</span>
      {endIcon}
    </MenuItem>
  );
};

export { UserMenuItem };
